import Vue  from "vue";
import Tabs from './components/vue-tabs';
import Collapse from './components/Collapse'

Vue.use(Tabs);

if (document.getElementById('pricing')) {
	const pricing = new Vue({
		el: '#pricing',
		components: {
			Collapse
		}
	});
}

if (document.getElementById('options')) {
	const options = new Vue({
		el: '#options',
		components: {
			Collapse
		}
	});
}

if (document.getElementById('product-tabs')) {
	const options = new Vue({
		el: '#product-tabs',
		components: {
			Collapse
		}
	});
}